require('./bootstrap');

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';
import VueSplide from '@splidejs/vue-splide';

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({ el, app, props, plugin }) {
        const appCreated = createApp({ render: () => h(app, props) })
            .use(plugin)
            .use( VueSplide)

        appCreated
            .mixin({ methods: { route } })
            .mount(el);


        return appCreated;
    },
});

InertiaProgress.init({ color: '#4B5563' });
